'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _dec2, _class2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactScroll = require('react-scroll');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _Clean = require('./Clean200.css');

var _Clean2 = _interopRequireDefault(_Clean);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Clean200Links = (_dec = (0, _reactCssModules2.default)(_Clean2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Clean200Links, _Component);

  function Clean200Links() {
    (0, _classCallCheck3.default)(this, Clean200Links);
    return (0, _possibleConstructorReturn3.default)(this, (Clean200Links.__proto__ || (0, _getPrototypeOf2.default)(Clean200Links)).apply(this, arguments));
  }

  (0, _createClass3.default)(Clean200Links, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { 'textAlign': 'center' } },
        _react2.default.createElement(
          _reactScroll.Link,
          {
            to: 'clean200',
            spy: true,
            smooth: true,
            duration: 500,
            title: 'Clean200 companies'
          },
          _react2.default.createElement(
            'div',
            { styleName: 'clean200-company-link' },
            'Full list of 200 companies',
            _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-angle-double-down' })
          )
        )
      );
    }
  }]);
  return Clean200Links;
}(_react.Component)) || _class);
var Clean200 = (_dec2 = (0, _reactCssModules2.default)(_Clean2.default, { allowMultiple: true }), _dec2(_class2 = function (_Component2) {
  (0, _inherits3.default)(Clean200, _Component2);

  function Clean200() {
    (0, _classCallCheck3.default)(this, Clean200);
    return (0, _possibleConstructorReturn3.default)(this, (Clean200.__proto__ || (0, _getPrototypeOf2.default)(Clean200)).apply(this, arguments));
  }

  (0, _createClass3.default)(Clean200, [{
    key: 'render',
    value: function render() {
      var title = 'Clean200™: Investing in a clean energy future';
      var description = "Use Fossil Free Funds to find out if you're invested in companies leading the way with solutions for the transition to a clean energy future";
      var url = _config2.default.domain + _config2.default.routes.clean200;

      var clean200Logo = require('../../../static/images/clean-200-icon.png');
      var clean200Graphic = require('../../../static/images/clean200-graphic.png');
      var ckLogo = require('../../../static/images/corporate-knights-logo.png');
      var aysLogo = require('../../../static/images/asyousow.png');
      var clean200Graph = require('../../../static/images/2024-Clean-200-figure-1.png');

      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title, description, url),
        _react2.default.createElement(
          'div',
          { styleName: 'page' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'div',
              { styleName: 'cl200-logo-title-flex' },
              _react2.default.createElement('img', {
                styleName: 'cl200-logo-img',
                src: clean200Logo,
                alt: 'Clean200\u2122'
              }),
              _react2.default.createElement(
                'h1',
                { styleName: 'cl200-title' },
                _react2.default.createElement(
                  'span',
                  { style: { fontWeight: 300 } },
                  'CLEAN'
                ),
                '200',
                _react2.default.createElement(
                  'span',
                  { style: { fontWeight: 300 } },
                  '\u2122'
                ),
                _react2.default.createElement('br', null),
                'Investing in a clean energy future'
              )
            ),
            _react2.default.createElement('img', {
              styleName: 'cl200-graphic-img',
              src: clean200Graphic,
              alt: 'Clean200\u2122'
            }),
            _react2.default.createElement(
              'p',
              { styleName: 'lede' },
              'Over the past years, a growing movement of investors representing trillions of dollars in assets under management have divested some portion of their fossil fuel investments. But where to invest this capital? The corollary of divesting fossil fuels is re-investing in the clean energy future. As an invitation to a larger discussion of how we can invest in this future, ',
              _react2.default.createElement(
                'em',
                null,
                'As You Sow'
              ),
              ' and Corporate Knights created the ',
              _react2.default.createElement(
                'strong',
                null,
                'Clean200\u2122'
              ),
              ' \u2014 a list of 200 publicly traded companies that are leading the way with solutions for the transition to clean energy.'
            ),
            _react2.default.createElement(Clean200Links, null),
            _react2.default.createElement(
              'p',
              { styleName: 'logo-info' },
              'Brought to you by As You Sow and Corporate Knights'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'logo-img-wrap' },
              _react2.default.createElement(
                'div',
                { styleName: 'logo-img-cell' },
                _react2.default.createElement('img', {
                  styleName: 'logo-img-ays',
                  src: aysLogo,
                  alt: 'As You Sow'
                })
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'logo-img-cell' },
                _react2.default.createElement('img', {
                  styleName: 'logo-img-ck',
                  src: ckLogo,
                  alt: 'Corporate Knights'
                })
              )
            )
          ),
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'p',
              null,
              'The Clean200\u2122 is intended as the clean energy inverse of the ',
              _react2.default.createElement(
                _components.Link,
                { to: _config2.default.routes.carbonunderground200, title: 'Carbon Underground 200', xstrong: true },
                'Carbon Underground 200\u2122.'
              ),
              ' Where the Carbon Underground 200\u2122 (which evolved from the seminal Carbon Tracker Initiative report, ',
              _react2.default.createElement(
                _components.Link,
                { to: 'http://www.carbontracker.org/report/carbon-bubble/', title: 'Unburnable Carbon: Are the World\u2019s Financial Markets Carrying a Carbon Bubble? | Carbon Tracker', xstrong: true },
                _react2.default.createElement(
                  'em',
                  null,
                  'Unburnable Carbon: Are the World\u2019s Financial Markets Carrying a Carbon Bubble?'
                )
              ),
              '), ranks the largest publicly listed companies by the carbon intensity of their coal, oil, and gas reserves; the Clean200\u2122 ranks the largest publicly listed companies by their total clean energy revenues, with a few additional screens to help ensure the companies are indeed building the infrastructure and services needed for what Lester Brown and many others have called ',
              _react2.default.createElement(
                _components.Link,
                { to: 'http://www.earth-policy.org/books/tgt', title: 'The Great Energy Transition | Earth Policy Institute', xstrong: true },
                '\u201CThe Great Energy Transition\u201D'
              ),
              ' in a just and equitable way.'
            ),
            _react2.default.createElement(
              'h2',
              { styleName: 'section-title' },
              '2024 update'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Just a few years ago, much of the business community viewed climate change with indifference or skepticism. Today, companies representing 40% of the global stock market have committed to science-based targets around reducing their greenhouse gas emissions in line with the Paris Agreement. In many cases, these businesses are already making billions of dollars supplying climate solutions to the market. Even corporations that are less directly implicated in the economic upside of climate action recognize the imperative for a low-carbon economy because no business can profit in an environment of climate chaos.'
            ),
            _react2.default.createElement(Clean200Links, null),
            _react2.default.createElement(
              'p',
              null,
              'Yet, despite this reality being clear as day, we are plodding along on climate action. Worse, a handful of laggard companies and their pliant industry associations continue to advocate against climate action and for business as usual. The first thing we need to do is cut the poison that is at the heart of our climate breakdown.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'That means finally cutting out the annual US$6 trillion in subsidies to fossil fuel companies that accounts for two-thirds of global greenhouse gas emissions.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'It also means cutting off financing for new fossil fuel projects, which ',
              _react2.default.createElement(
                _components.Link,
                { to: 'https://www.corporateknights.com/category-finance/hsbc-to-stop-financing-new-oil-and-gas-fields-except-in-canada/', xstrong: true, title: 'HSBC' },
                'HSBC'
              ),
              ' (one of the largest banks in the world) and Lloyds (the largest domestic bank in the U.K.) have done for new oil and gas fields \u2013 with some caveats.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'And it means stopping all financing for activities that are killing our forests. Deforestation accounts for 11% of global greenhouse gas emissions, more than comes out of the tailpipes of all 1.4 billion cars on the world\u2019s roads. If we went a step further than putting a stop to ripping out our forests and mangroves and started to restore them, we could get almost 40% of the way to our Paris Agreement goals by 2030.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'But as former Bank of England (and Canada) governor Mark Carney has made clear, \u201Cthe biggest threat to achieving 1.5 degrees C is the speed at which we invest, not divest. We need at least $4 in clean energy investment for every $1 maintaining fossil fuels until we can phase them out by the end of this decade.\u201D The transition to a low-carbon economy will require US$200 trillion of funds between now and 2050. That works out to about US$7 trillion a year. This is not an impossible lift for a global economy that generates US$100 trillion a year of gross domestic product.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The good news is that over the past decade, the flow of money into clean energy and efficiency infrastructure has tripled to US$1.1 trillion annually. According to research from Bloomberg, global investments in clean energy transition reached US$1.1 trillion in 2022, growing at a three-year annualized rate of 29%. This amount was roughly equal to the amount invested in fossil fuel production in the same year. At this rate, by the end of this decade, we will exceed the US$7 trillion per year we need to be deploying.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The good news is that the exponential growth of the sustainable economy is not confined just to clean energy; it is now embedded as a dominant macroeconomic growth trend, with large publicly traded companies growing their sustainable revenues and investments at double the rate of general revenues and investments over the past three years.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The Corporate Knights\u2019 Sustainable Economy Database covers over 3,000 companies in every sector of the economy, with more than $65 trillion in revenue. Across this group, sustainable revenue grew 63% (18% compound annual growth rate) from 2019-2022, twice as fast as gross revenue and four times faster than global GDP.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'None of this means we can rest on our laurels. The fossil fuel industry is flush with cash, existentially motivated, and ferociously well-organized to put up political barriers.  They are launching propaganda campaigns to convince us all that \u201Cchange is impossible,\u201D intended to delay the inevitable transition to a low-carbon sustainable economy.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The companies that want swifter climate action in alignment with the Paris Agreement\u2014publicly traded companies signed up to the Science Based Targets Initiative (SBTi)\u2014 have seven times more economic power (earning USD $28 trillion in the most recent fiscal year according to Corporate Knights calculations) than the $4 trillion haul made by the fossil fuel industry (itself a huge rise from its recent average of $1.5 trillion).'
            ),
            _react2.default.createElement(
              'p',
              null,
              'This economic power must be translated into political power to address barriers to climate action, chief among them unacceptably long permitting times for renewable energy projects.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'This is beginning to happen with work led by the Corporate Knights Global 100 Council and others to galvanize the voice of business\u2014not just the green energy companies -- as a voice for speeding up climate action. This was demonstrated at this year\u2019s annual UN Climate Change Conference, COP28 (the first COP agreement to include a renewable energy target) where business calls spanning all sectors for more clean energy were met with a pledge to triple installed renewable energy to 11,000 GW by 2030. While the fossil fuel industry is more powerful politically, both science and economic power are on the side of companies who want to speed up climate action. The current imperative is to focus on speeding up action here and now, not far-off 2050 declarations.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'At COP28, world leaders agreed to a roadmap that zeroed in on fossil fuels and the necessity of \u201Ctransitioning away\u201D from them \u201Cin our energy systems in a just, orderly, and equitable manner.\u201D This was historic and insufficient, as the chair of the Fossil Fuel Non-Proliferation Treaty, Tzeporah Berman, put it. It was historic because, for the first time in 28 UN climate summits, the enemy of a safe climate was specifically called out. And it was insufficient because there was no commitment to an outright phaseout of fossil fuels like the world successfully did in the 1980s with chlorofluorocarbons (CFCs) to stop the destruction of the ozone layer. It was also insufficient because the renewable projects required to transform our energy system are still largely underfunded.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The Clean200 lists the 200 major corporate players from 35 countries around the world that are at the forefront of this transition. These are the companies that are leading the way by putting sustainability at the heart of their products, services, business models, and investments, helping to move the world onto a more sustainable trajectory.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'This year\u2019s Clean200 companies rose to the top of a pool of 6,730 global firms based on a rigorous assessment of the amount of revenue each company earns from products and services aligned with the Corporate Knights Sustainable Economy Taxonomy, while also ensuring that their businesses are not fundamentally offside important criteria for socially responsible investors, including being a company flagged by ',
              _react2.default.createElement(
                'i',
                null,
                'As You Sow\u2019s'
              ),
              ' ',
              _react2.default.createElement(
                _components.Link,
                { to: _config2.default.links.iyv, xstrong: true, title: 'Invest Your Values' },
                'Invest Your Values'
              ),
              '  platform, which identifies fossil fuels, weapons, private prisons, thermal coal or having a record of systemically obstructing climate policy.'
            ),
            _react2.default.createElement(
              'h3',
              { styleName: 'section-subtitle' },
              'Key findings'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Geographically, the Asia-Pacific region, Europe, and North America account for 34%, 33%, and 26% respectively of this year\u2019s Clean200, while the remaining 15 companies are headquartered in the Middle East, Africa, and South America. The United States dominated the 2024 list, with 39 companies on the Clean200, while China had the second-largest share with 23, followed by Japan, which is the headquarters of 18 Clean200 companies.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'On average, 54.7% of revenues earned by Clean200 companies are classified as sustainable, representing over $2.2 trillion in revenue, significantly above the 13.6% average sustainable revenue for their MSCI ACWI peers.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Of note, it was found that on average, 43.6% of the capital expenditure, acquisitions, and research and development expenses among the Clean200 companies were defined as sustainable by the Corporate Knights Sustainable Economy Taxonomy (CK SET), compared to only 17.2% among MSCI ACWI constituents.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Of the companies that made the 2024 Clean200 list, the Information Technology sector accounted for over a quarter of the total sustainable revenue at $643 billion, followed by the Industrials sector ($504 billion) and the Consumer Discretionary sector ($378 billion). On Sustainable Investments, the Communication Services sector led with $99 billion, followed by the Utilities sector with $77 billion and the Industrials sector with $55 billion of CK SET-aligned investments.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Taiwanese companies had, on average, the highest Sustainable Revenue at $18.7 billion. This is followed by the United States with $18.2 billion and South Korea at $15.4 billion.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'None of this would have legs if the Clean200 weren\u2019t also faring well financially. On this score, as of January 15, 2024, the Clean200 outperformed the MSCI ACWI/Energy Index of fossil fuel companies on Total Return Gross \u2014 USD Basis from the Clean200 inception of July 1, 2016, 103.5% against 64.5%, and this despite the uptick in Energy stocks prices since mid-2020 and exacerbated by the Russian invasion of Ukraine.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'To put that in context: $10,000 invested in the Clean200 on July 1, 2016, would have grown to $20,346 by Jan. 15, 2024, versus $16,453 for the MSCI ACWI/Energy benchmark for fossil fuel companies. The Clean 200 however underperformed the MSCI ACWI, which returned 114.4% over the same time period.'
            ),
            _react2.default.createElement(
              'h3',
              { styleName: 'section-subtitle' },
              'Looking ahead'
            ),
            _react2.default.createElement(
              'p',
              null,
              'This decade we need to move faster, quadrupling current levels of investment to the US$4 trillion annually (4% of global GDP) that is required, according to the ',
              _react2.default.createElement(
                _components.Link,
                { to: 'https://www.iea.org/reports/net-zero-by-2050', xstrong: true, title: 'International Energy Agency' },
                'International Energy Agency'
              ),
              '.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Finance ministers hold the keys to unlocking climate action. Fortunately, a new group, called the Coalition of Finance Ministers for Climate Action, from more than 80 countries, is looking to shift the view of climate action from a cost to a unique growth and investment opportunity. These finance ministers recognize that the current energy crisis and growing incidence of climate hazards are an opportunity for more, not less, action. And a rapid switch to renewable energy presents an opportunity for countries to deliver clean, cheap, secure energy and new employment at the same time.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Finance ministers globally manage huge annual budgets that collectively add up to around 30% of gross domestic product. Mobilizing 4% of global GDP for climate action is not going to happen without backing from heads of state, most critically those from the G20 countries. It is a tall task but one with precedent. It wasn\u2019t that long ago that governments mobilized trillions of dollars to keep businesses and workers afloat during the early days of the COVID-19 pandemic.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Corporate Knights and As You Sow are pleased to present the latest edition of the Clean200 to help investors identify the companies that are leading the charge on providing climate solutions while outperforming both the broad-based benchmark and its high-carbon global counterparts.'
            ),
            _react2.default.createElement(Clean200Links, null),
            _react2.default.createElement(
              'h2',
              { styleName: 'section-subtitle' },
              'Clean200\u2122 vs MSCI ACWI vs MSCI ACWI/Energy (July 1, 2016\u2013Jan. 31, 2024, Total Return USD Gross)'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'cl200-graph-wrap' },
              _react2.default.createElement(
                _components.Link,
                {
                  to: clean200Graph,
                  title: 'Clean200\u2122 vs MSCI ACWI vs MSCI ACWI/Energy (July 1, 2016\u2013Jan. 31, 2024, Total Return USD Gross)',
                  targetBlank: true
                },
                _react2.default.createElement('img', {
                  styleName: 'cl200-graph',
                  src: clean200Graph,
                  alt: 'Clean200\u2122 vs MSCI ACWI vs MSCI ACWI/Energy (July 1, 2016\u2013Jan. 31, 2024, Total Return USD Gross)'
                })
              ),
              _react2.default.createElement(
                'p',
                { style: { textAlign: 'left' } },
                _react2.default.createElement(
                  'small',
                  null,
                  _react2.default.createElement(
                    'em',
                    null,
                    'Source: S&P Capital IQ'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'h2',
              { styleName: 'section-subtitle' },
              'Clean200\u2122 methodology'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The Clean200\u2122 are the largest 200 public companies ranked by clean revenue. The ranking was first calculated on July 1, 2016, and publicly released on August 15, 2016, by Corporate Knights and ',
              _react2.default.createElement(
                'em',
                null,
                'As You Sow'
              ),
              '. The current list has been updated with data through January 15, 2024.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The Clean200\u2122 companies are ranked by their clean revenues in U.S. dollars. The data set is developed through assessment of a company\u2019s revenue that aligns with the definitions laid out in the ',
              _react2.default.createElement(
                _components.Link,
                { to: 'https://www.corporateknights.com/resources/corporate-knights-clean-taxonomy/', title: 'Corporate Knights Sustainable Economy Taxonomy', xstrong: true },
                'Corporate Knights Sustainable Economy Taxonomy'
              ),
              ', primarily sourced from Corporate Knights research. To be eligible, a company must earn more than 10% of total revenues from clean sources.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'The Clean200\u2122 uses negative screens. It excludes all oil and gas companies, all utilities that generate less than 50% of their power from green sources, the top 100 coal companies measured by reserves, the top 100 oil and gas companies as measured by reserves, as well as all fossil fuel companies, majority fossil-fired utilities, pipeline and oil-field-services companies, and other fossil-fuel-related companies screened on ',
              _react2.default.createElement(
                'em',
                null,
                'As You Sow\u2019s'
              ),
              ' ',
              _react2.default.createElement(
                _components.Link,
                { to: _config2.default.routes.home, title: 'Fossil Free Funds', xstrong: true },
                'Fossil Free Funds'
              ),
              '. In addition, the Clean200\u2122 excludes weapons companies, including major military arms manufacturers found on the Stockholm International Peace Research Institute (SIPRI) Top 100 arms-producing and military services list, as well as cluster munitions, nuclear weapons and civilian firearm manufacturers screened on ',
              _react2.default.createElement(
                'em',
                null,
                'As You Sow\u2019s'
              ),
              ' ',
              _react2.default.createElement(
                _components.Link,
                { to: _config2.default.links.wff, title: 'Weapon Free Funds', xstrong: true },
                'Weapon Free Funds'
              ),
              '. The Clean200\u2122 also excludes palm oil, paper/pulp, rubber, timber, cattle and soy producers that are screened on ',
              _react2.default.createElement(
                'em',
                null,
                'As You Sow\u2019s'
              ),
              ' ',
              _react2.default.createElement(
                _components.Link,
                { to: _config2.default.links.dff, title: 'Deforestation Free Funds', xstrong: true },
                'Deforestation Free Funds'
              ),
              '; companies that use child or forced labour, are involved in the manufacture of harmful pesticides, and that engage in negative climate lobbying are not included.'
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'h2',
              { styleName: 'section-subtitle' },
              'Clean200\u2122 companies'
            ),
            _react2.default.createElement(_components.ScreenedCompanies, { clean200: true })
          ),
          _react2.default.createElement(_components.GetStartedInput, null),
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(_components.AboutBanner, null)
          )
        )
      );
    }
  }]);
  return Clean200;
}(_react.Component)) || _class2);
exports.default = Clean200;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Clean200/Clean200.js
// module id = 1397
// module chunks = 0